import { Injectable } from '@angular/core';
import { map, mergeMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Observable, EMPTY, of, forkJoin } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { SocoHttpService } from '@soco/http';
import { SocoConfigurationService } from '@soco/configuration';

import { ApiResult } from '@soco/core';
import { Sample } from '../sample/sample';
import { url } from 'inspector';

@Injectable()
export class HttpService {

    public baseUrl = '/orderdetails/';
    public rescheduleBaseUrl = '/Reschedule/';
    public account: any = {};

  //'https://localhost:44339/api/https://localhost:44339/api/orderdetails/50962817?id=5096

  constructor(private http: SocoHttpService, private ngHttp: HttpClient, private config: SocoConfigurationService) { }


  // public resolveAnonymousAccountInfo(id: string, alertId?: string): Observable<any> {
  //   return this.ngHttp.get<ApiResult<any>>('https://localhost:44371/Account/GetAnonymousApiInfo').pipe(mergeMap((res: any) => {
  //     this.setApiInfo(res.data);
  //     return forkJoin([
  //       this.getData(id).pipe(map((result) => {
  //         // Return an empty observable, as there no other consequent calls to API
  //         console.log('companiesResult--------->', result);
  //         return EMPTY;
  //       }))
  //   }));
  // }
    
  //
  getData(id: string, alertId?: string): Observable<ApiResult<any>> {
    // console.log("return url is:--->"+'https://localhost:44339/api/orderdetails/'+guid);
    return this.http.get<any>({
      url: this.baseUrl + id,
    });
    }

    getOrderAttributes(urlCode: string) {
        return this.http.get<any>({
            url: this.rescheduleBaseUrl + 'GetOrderAttributes/' + urlCode
        });
    }

  //   getById(id: number, alertId?: string): Observable<ApiResult<any>> {
  //     //DSS Documentation on SocoHttpService - http://tiny.sc/cgSocoHttpService
  //     //DSS Documentation on handling exceptions - http://tiny.sc/cgclientexceptions
  //     return this.http.get<any>({
  //         url: 'https://localhost:44339/api/orderdetails/'+id,
  //         params: { id: id },
  //         alertId: alertId
  //     });
  // }

  private setApiInfo(info: any) {
    console.log('inside SetAPIINFO');
    this.account.apiInfo = info;
    if (this.account.apiInfo.webApiBaseUrl[this.account.apiInfo.webApiBaseUrl.length - 1] !== '/') {
      this.account.apiInfo.webApiBaseUrl += '/';
    }
    this.config.webApiToken = this.account.apiInfo.webApiToken;
    this.config.webApiBaseUrl = this.account.apiInfo.webApiBaseUrl;
    this.config.coolSecurityToken = this.account.apiInfo.coolSecurityToken;
  }

  // For http GET operations.
  //   public getJSONData(path) {
  //     return this.http.get(path)
  //       .map((resp) => (resp.json()));
  //   }

  //   public getData(path) {
  //     return this.http.get(path);
  //   }

  // For Dictionaries http GET operations.
  //   public getDictionaryJSONData(path, dictId) {
  //     return this.http.get(path)
  //         .map((res: Response) => {
  //           const dictObj = {};
  //           dictObj[dictId.dictionaryId] = res.json()[dictId.dictionaryId];
  //           return dictObj;
  //       }).catch(this.handleError);
  //   }

  // For http POST operations
  //   public getHttp(url, paramData): Observable<any[]> {
  //     // let headers      = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
  //     // let options       = new RequestOptions({ headers: headers }); // Create a request option

  //     return this.http.post(url, paramData)
  //       .map(data => data)
  //       .catch(this.handleError);
  //   }

  // Error call back for http requests.
  private handleError(error: any) {

    // const errMsg = (error.message) ? error.message :
    //   error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    // return Observable.throw(errMsg);
  }

}
